import * as React from "react";
import { I18nextProvider } from "react-i18next";

import i18n from "./i18n";

import { OldBrowserStub } from "UIKit";

const oldBrowserApplication = () => <I18nextProvider i18n={i18n}>
        <OldBrowserStub />
    </I18nextProvider>;

export default oldBrowserApplication;